<template>
  <div class="list-wrap" @click="listTap">
    <div class="list-top">
      <van-image class="list-img" :src="item.coverUrl" fit="cover" />
      <div class="list-main">
        <div class="list-title">{{ item.activityName }}</div>
        <div>
          <div class="list-tab">{{ item.county }}</div>
          <div class="list-time">
            {{ item.startTimeStr }} {{ item.startWeek }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="list-status"
      :class="{
        'list-status-green': item.status == 2,
        'list-status-white': item.status == 3
      }"
    >
      {{ item.statusText }}
    </div>
    <div class="list-bottom">
      <div class="list-num">{{ item.joinCount }}人报名</div>
      <div
        class="list-btn"
        v-if="item.signStatus != 4 && item.status != 3"
        @click.stop="joinTap"
      >
        {{
          item.signStatus == 2 || item.signStatus == 3 ? '活动签到' : '我要报名'
        }}
      </div>
    </div>
  </div>
</template>
<script>
/**
 * status: 状态：1.未开始，2.进行中，3.已结束
 * isSign: 否签到（0. 未签到，1.已签到）
 * signStatus: 报名状态: 1.未报名，2.已报名，3.未签到，4.已签到
 */
import { Toast } from 'vant'
import { Dialog } from 'vant'
import {
  addSignRecord,
  updateSignRecord,
  visitActivity
} from '@api/lishui/active'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  props: ['item'],
  data() {
    return {
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  methods: {
    listTap() {
      this.buriedPoint()
      this.buriedPoint1()
      this.$router.push({
        path: '/active/details',
        query: {
          id: this.item.id
        }
      })
    },
    // 埋点
    buriedPoint(e) {
      const params = {
        id: this.item.id
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      visitActivity(params).then(res => {})
    },
    // 埋点
    buriedPoint1() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    joinTap() {
      if (this.item.signStatus == 1) {
        this.buriedPoint()
        this.buriedPoint1()
        if (this.item.joinCount >= this.item.numSet) {
          Toast('报名人数已满')
        } else {
          Dialog.confirm({
            title: '提醒',
            message: '确定要报名活动吗？'
          }).then(() => {
            // 报名
            const params = {
              activityId: this.item.id,
              isSign: 0
            }
            addSignRecord(params).then(res => {
              const { code, data, msg } = res.data
              if (code == '0000') {
                Toast(msg)
                this.$emit('listUp')
              } else {
                Toast(msg)
              }
            })
          })
        }
      } else if (this.item.signStatus == 2 || this.item.signStatus == 3) {
        // 签到
        const params = {
          signRecordId: this.item.signRecordId,
          isSign: 1
        }
        updateSignRecord(params).then(res => {
          const { code, data, msg } = res.data
          if (code == '0000') {
            Toast(msg)
            this.$emit('listUp')
          } else {
            Toast(msg)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-wrap {
  padding: 15px 15px 0;
  position: relative;
  &:last-child {
    border: none;
  }
  .list-top {
    display: flex;
    .list-img {
      width: 130px;
      height: 78px;
      border-radius: 6px;
      overflow: hidden;
    }
    .list-main {
      flex: 1;
      overflow: hidden;
      padding-left: 4px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .list-title {
        font-size: 14px;
        color: #333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .list-tab {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .list-tab,
      .list-time {
        font-size: 12px;
        color: #999;
        margin-top: 6px;
      }
    }
  }
  .list-status {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .list-status-green {
    background: rgba(0, 184, 102, 0.7);
  }
  .list-status-white {
    background: rgba(255, 255, 255, 0.7);
    color: #333;
  }
  .list-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .list-num {
      color: #0070ff;
      font-size: 12px;
      padding: 12px 0;
    }
    .list-btn {
      color: #0070ff;
      font-size: 12px;
      padding: 4px 12px;
      border: 1px solid #0070ff;
      border-radius: 20px;
    }
  }
}
</style>
